/** @file bandWords: the pitch ranges of a facet entry in words (level, tipped down, tipped up). */

/** One pitch range name in words; the range name stays in brackets so the line can be checked against `slots`. */
function rangeWords(range: string): string {
  if (range === 'ALL') return 'level look (ALL)';
  if (range.startsWith('DOWN')) return `part tipped down (${range})`;
  if (range.startsWith('UP')) return `part tipped up (${range})`;
  if (range.startsWith('BACK')) return `part tipped back (${range})`;
  if (range.startsWith('NORM')) return `normal look (${range})`;
  return range;
}

/** The entry's ranges joined with `or`: `level look (ALL)`, `part tipped down (DOWN1+)`. */
export function bandWords(bands: readonly string[]): string {
  return bands.length === 0 ? 'level look (ALL)' : bands.map(rangeWords).join(' or ');
}
